import React from "react";

import { Button } from "@mui/material";

import RoundSlide from "../../../assets/images/slide.svg";
import ExcellenceBG from "../../../assets/images/ExcellenceBG.svg";

// Style
import Styles from "./ExcellenceProgram.module.css";

// Custom Components
import QuickLinks from "../QuickLinks/QuickLinks";
import Footer from "../../../components/Reusable/Footer/Footer";


const ExcellenceProgram: React.FC = () => {
  
  return (
    <div className={Styles.container}>
      <img
        src={ExcellenceBG}
        width={300}
        height={300}
        alt="Excellence Background"
        className={Styles.excellenceBg}
      />

      <div className={Styles.programContainer}>
        <div className={Styles.subprogramContainer}>
          <div className={Styles.contentDiv}>
            <div>
              <span style={{ color: "var(--ABI-Color, #D7A833)", marginRight: "10px" }}>
                {localStorage.getItem("userName")}
              </span>
              <span>Welcome to</span>
            </div>
            <h1>
              GBS <span>STAR</span> Excellence Program
            </h1>
            <p>
              Building the Top GBS by creating an excellence program to
              standardize, transform & accelerate results
            </p>
            <Button
              component="a"
              href="https://anheuserbuschinbev.sharepoint.com/:p:/s/GlobalOperationalExcellenceProgram/ERF81lgdJoxCrbCVTtKnk2sBNhM1LmU7XRlP0vUvJPJP8w?e=YWTfcM"
              target="_blank"
              variant="contained"
              sx={{
                background:
                  "linear-gradient(238deg, #D7A833 1.68%, #F4DF03 91.8%)",
                padding: "10px 30px",
                fontWeight: "600",
                textTransform: "capitalize",
                width: "max-content"
              }}
            >
              Know More
            </Button>
          </div>
          <div style={{ margin: "auto" }}>
            <img src={RoundSlide} alt="Round Slide" height={400} />
          </div>
        </div>
      </div>

      <div>
        <QuickLinks />
      </div>

      <div style={{position:"absolute", bottom: 0, width:"100%"}}>
        <Footer />
      </div>
    </div>
  );
};

export default ExcellenceProgram;
